<fui-select-control class="user-select"
  [options]="options"
  [(value)]="selectedValue"
  (valueChange)="updateStateOnValueChange()"
  [disabled]="disabled"
  [labelField]="'label'"
  [label]="label"
  [loading]="false"
  [placeholder]="' '"
  [valueField]="'value'"
  [internallyFilterable]="true"
  (removed$)="removed.emit()"
  [allowClearSelectionOption]="false"
  [showExtendedSearchOption]="false"
  [removable]="false"
  [showAddOption]="false">
</fui-select-control>
@if (required && !selectedValue) {
  <div class="user-error">
    Required
  </div>
}
